<template>
  <div class="overlay" @click.self="$emit('close')">
    <div class="modal-box">
      <div class="modal-head">
        <div>
          <h3 class="modal-title">📦 {{ aksiya.name }}</h3>
          <div class="modal-sub">{{ products.length }} ta mahsulot</div>
        </div>
        <div class="head-actions">
          <button class="btn-add-mini" @click="openProductForm()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>
            Qo'shish
          </button>
          <button class="close-btn" @click="$emit('close')">&times;</button>
        </div>
      </div>

      <div class="modal-body">
        <div v-if="loading" class="empty-state">Yuklanmoqda...</div>
        <div v-else-if="products.length === 0" class="empty-state">
          Hali mahsulot yo'q. <button class="link-btn" @click="openProductForm()">Yangisini qo'shing</button>
        </div>

        <div v-else class="prod-grid">
          <div v-for="p in products" :key="p.id" class="prod-card" :class="{ 'inactive': !p.is_active }">
            <div class="prod-image">
              <img v-if="p.image" :src="p.image" :alt="p.name" />
              <div v-else class="prod-placeholder">📦</div>
            </div>
            <div class="prod-body">
              <div class="prod-name">{{ p.name }}</div>
              <div class="prod-price">🎁 <b>{{ p.ball_price }}</b> ball</div>
              <div class="prod-actions">
                <button class="btn-give" @click="openGive(p)" title="Ustaga berish">
                  Ustaga berish
                </button>
                <button class="btn-icon edit" @click="openProductForm(p)" title="Tahrirlash">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                </button>
                <button class="btn-icon del" @click="deleteProduct(p)" title="O'chirish">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product CRUD modal -->
    <ProductForm
      v-if="productForm.show"
      v-model="productForm.show"
      :aksiya-id="aksiya.id"
      :edit-item="productForm.item"
      @saved="onProductSaved"
    />

    <!-- Give to usta modal -->
    <GiveModal
      v-if="giveModal.show"
      v-model="giveModal.show"
      :product="giveModal.product"
      :ustalar="ustalar"
      @given="onProductGiven"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ProductForm from './ProductForm.vue';
import GiveModal from './GiveModal.vue';

export default {
  name: 'AksiyaProductsModal',
  components: { ProductForm, GiveModal },
  props: {
    aksiya:  { type: Object, required: true },
    ustalar: { type: Array,  default: () => [] },
  },
  data() {
    return {
      loading: false,
      products: [],
      productForm: { show: false, item: null },
      giveModal:   { show: false, product: null },
    };
  },
  mounted() { this.fetchProducts(); },
  methods: {
    async fetchProducts() {
      this.loading = true;
      try {
        const res = await axios.get(`/api/v1/ball-product?aksiya_id=${this.aksiya.id}`);
        this.products = res.data.data || [];
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },

    openProductForm(p = null) {
      this.productForm = { show: true, item: p ? { ...p } : null };
    },
    onProductSaved() {
      this.fetchProducts();
      this.$emit('refresh');
    },

    async deleteProduct(p) {
      if (!confirm(`"${p.name}" o'chirilsinmi?`)) return;
      try {
        await axios.delete(`/api/v1/ball-product/${p.id}`);
        this.fetchProducts();
        this.$emit('refresh');
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      }
    },

    openGive(p) {
      this.giveModal = { show: true, product: p };
    },
    onProductGiven() {
      this.fetchProducts();
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed; inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 9000;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.modal-box {
  background: white; border-radius: 24px;
  width: 880px; max-width: 96vw;
  max-height: 92vh;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
  display: flex; flex-direction: column;
  overflow: hidden;
}
.modal-head {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.modal-sub { font-size: 12px; color: #94a3b8; margin-top: 2px; }
.head-actions { display: flex; gap: 10px; align-items: center; }
.btn-add-mini {
  display: flex; align-items: center; gap: 5px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none;
  height: 36px; padding: 0 14px; border-radius: 10px;
  font-weight: 700; font-size: 12px; cursor: pointer;
}
.close-btn {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
  display: flex; align-items: center; justify-content: center;
}
.modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}
.empty-state {
  text-align: center; padding: 60px 20px;
  color: #94a3b8; font-weight: 600;
}
.link-btn { background: none; border: none; color: #5850ec; font-weight: 700; cursor: pointer; text-decoration: underline; }

.prod-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 14px;
}
.prod-card {
  background: white;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: hidden;
  transition: 0.15s;
}
.prod-card:hover { box-shadow: 0 6px 18px rgba(0,0,0,0.08); }
.prod-card.inactive { opacity: 0.6; }
.prod-image {
  height: 130px;
  background: #f8fafc;
  display: flex; align-items: center; justify-content: center;
}
.prod-image img { width: 100%; height: 100%; object-fit: cover; }
.prod-placeholder { font-size: 40px; opacity: 0.5; }
.prod-body { padding: 12px; display: flex; flex-direction: column; gap: 8px; }
.prod-name { font-size: 13px; font-weight: 700; color: #1e293b; line-height: 1.2;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.prod-price { font-size: 13px; color: #92400e; }
.prod-price b { font-size: 16px; font-weight: 900; color: #d97706; }
.prod-actions { display: flex; gap: 6px; align-items: center; }
.btn-give {
  flex: 1;
  height: 32px;
  background: #dcfce7; color: #166534;
  border: 1.5px solid #86efac;
  border-radius: 8px;
  font-size: 11px; font-weight: 800;
  cursor: pointer; transition: 0.15s;
}
.btn-give:hover { background: #16a34a; color: white; border-color: #16a34a; }
.btn-icon {
  width: 32px; height: 32px;
  border: none; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
}
.btn-icon.edit { background: #f5f3ff; color: #5850ec; }
.btn-icon.del  { background: #fff1f2; color: #e11d48; }
.btn-icon:hover { filter: brightness(0.92); }
</style>
